module.exports = __webpack_public_path__ + "src/img/noticeIcon.93f412fd.svg";